import { render, staticRenderFns } from "./LicenseCard.vue?vue&type=template&id=4e0ca943"
import script from "./LicenseCard.vue?vue&type=script&lang=ts"
export * from "./LicenseCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports